import { call, take, put } from 'redux-saga/effects';
import { post, get, putMethod } from '../../utils/api';
import settings from '../../utils/settings';

import {
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_REQUEST_FAILURE,
  CREATE_USER_REQUEST,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  UPDATE_USER_SUCCESS
} from './constants';

export function* getUserList() {
  while (true) {
    const request = yield take(USER_LIST_REQUEST);
    try {
      let response;
      const { companyId, page, limit, user } = request.payload;
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/installers`),
        body: { user, page, limit }
      });
      if (response.success) {
        const { result } = response;
        if (result !== []) {
          yield put({ type: USER_LIST_SUCCESS, userList: response.result, masterData: response.result.master_data });
        } else {
          yield put({ type: USER_REQUEST_FAILURE, error: result.message });
        }
      }
    } catch (error) {
      console.log('Saga: getUserList:', error);
      yield put({ type: USER_REQUEST_FAILURE, error: error });
    }
  }
}

export function* createUser() {
  while (true) {
    const request = yield take(CREATE_USER_REQUEST);
    const { body, successCbk } = request.payload;
    try {
      let response;
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/users`),
        body
      });
      const { success, result } = response;
      if (success) {
        successCbk();
      } else {
        yield put({ type: USER_REQUEST_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: USER_REQUEST_FAILURE, error });
    }
  }
}

export function* getUserData() {
  while (true) {
    const request = yield take(GET_USER_REQUEST);
    const { userId, body = {}, isUpdate = false, successCbk } = request.payload;
    try {
      let response;
      if (isUpdate) {
        response = yield call(putMethod, {
          url: settings.getApiUrl(`service/enlm_ms/api_internal/users/${userId}`),
          body
        });
      } else {
        response = yield call(get, {
          url: settings.getApiUrl(`service/enlm_ms/api_internal/users/${userId}`)
        });
      }
      const { success, result } = response;
      if (success) {
        if (isUpdate) {
          yield put({ type: UPDATE_USER_SUCCESS, message: result.message, userId: userId });
          successCbk();
        } else {
          yield put({ type: GET_USER_SUCCESS, userDetail: response.result, userId: userId });
        }
      } else {
        yield put({ type: USER_REQUEST_FAILURE, error: result.message || result.messages });
      }
    } catch (error) {
      yield put({ type: USER_REQUEST_FAILURE, error });
    }
  }
}
